<template>
  <div
    v-if="destinations.length"
    class="card card-custom card-stretch gutter-b"
  >
    <div class="card-body">
      <div class="font-size-h6 mb-5 d-flex justify-content-between">
        <div>مقصد‌های خروجی را از لیست مقصد‌‌های خود انتخاب کنید.</div>
        <div>
          <div v-show="!destinationsLoaded" class="spinner mr-3"></div>
        </div>
      </div>
      <b-overlay :show="!setProgramDestinationLoaded" opacity="0.1">
        <div class="d-flex flex-wrap">
          <div
            v-for="destination in destinations"
            :key="destination.id"
            @click="setProgramDestination(destination.id)"
            class="card m-2 text-center cursor-pointer w-160px"
            :class="{
              'selected-destination': programDestinationsIds.includes(
                destination.id
              ),
              'bg-light': !programDestinationsIds.includes(destination.id)
            }"
          >
            <div class="card-body p-3">
              <div
                class="w-auto btn-clean d-flex px-1"
                :title="destination.name"
              >
                <span class="symbol symbol-20 symbol-light-success">
                  <img
                    :alt="destination.name"
                    :src="
                      `/media/destinations/${
                        destinationTypes[destination.type]
                      }.png`
                    "
                  />
                </span>
                <span
                  class="ml-2 font-size-md w-150px text-overflow-ellipsis text-left"
                >
                  {{ destination.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>

      <div
        class="overflow-auto mt-5"
        v-if="
          destinationsPagination.lastPage > 1 ||
            destinationsPagination.currentPage > 1
        "
      >
        <b-pagination
          v-model="destinationsPagination.currentPage"
          :total-rows="destinationsPagination.total"
          :per-page="destinationsPagination.perPage"
          aria-controls="my-table"
          @input="getDestinations()"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DESTINATIONS } from "@/core/services/store/destinations.module";
import {
  FETCH_PROGRAM_DESTINATIONS,
  STORE_PROGRAM_DESTINATION,
  DESTROY_PROGRAM_DESTINATION
} from "@/core/services/store/programs.module";

export default {
  name: "ProgramDestinations",
  data() {
    return {
      setProgramDestinationLoaded: true,
      destinationsLoaded: false,
      destinationsInterval: null,
      isCompany: this.$route.name.startsWith("company")
    };
  },
  props: {
    program: Object
  },
  mounted() {
    this.getProgramDestinations();
    this.getDestinations();

    this.destinationsInterval = setInterval(() => {
      this.getProgramDestinations();
    }, 8000);
  },
  beforeDestroy: function() {
    clearInterval(this.destinationsInterval);
    this.destinationsInterval = null;
  },
  computed: {
    ...mapGetters([
      "destinationTypes",
      "destinations",
      "destinationsPagination",
      "programDestinations"
    ]),
    programDestinationsIds() {
      let array = [];
      this.programDestinations.forEach(function(sDestination) {
        array.push(sDestination["destination_id"]);
      });
      return array;
    }
  },
  methods: {
    getDestinations() {
      this.destinationsLoaded = false;

      this.$store
        .dispatch(FETCH_DESTINATIONS, {
          user: this.program.user_id
        })
        .then(() => {
          this.destinationsLoaded = true;
        })
        .catch(() => {
          this.destinationsLoaded = true;
        });
    },
    getProgramDestinations() {
      this.destinationsLoaded = false;

      this.$store
        .dispatch(FETCH_PROGRAM_DESTINATIONS, this.program.id)
        .then(() => {
          this.destinationsLoaded = true;
        })
        .catch(() => {
          this.destinationsLoaded = true;
        });
    },
    setProgramDestination(destinationId) {
      if (!this.setProgramDestinationLoaded) {
        return;
      }
      this.setProgramDestinationLoaded = false;

      if (this.programDestinationsIds.includes(destinationId)) {
        this.$store
          .dispatch(DESTROY_PROGRAM_DESTINATION, destinationId)
          .then(() => {
            this.setProgramDestinationLoaded = true;
          })
          .catch(() => {
            this.setProgramDestinationLoaded = true;
          });
      } else {
        this.$store
          .dispatch(STORE_PROGRAM_DESTINATION, {
            programId: this.program.id,
            destinationId: destinationId
          })
          .then(() => {
            this.setProgramDestinationLoaded = true;
          })
          .catch(() => {
            this.setProgramDestinationLoaded = true;
          });
      }
    }
  }
};
</script>
